export const useStateInfo = (stateInfo) => {
  return {
    isExpired: stateInfo?.is_expired === true || stateInfo?.isExpired === true,
  };
};
